export const styleLabelVars1 = {
  color: "#FFF",
  backgroundColor: "#000",
  borderRadius: ".4rem",
  padding: ".5rem 1rem",
  fontSize: "14px",
  cursor: "pointer"
}